<template>
  <div>
    <div class="header-search-sm-form active">
      <form class="search-form" @submit.prevent="search">

        <!-- Cannot use v-model due to a bug. See https://github.com/vuejs/vue/issues/8231 -->
        <input
          type="text"
          name="query"
          class="form-control search-input-sm"
          autocomplete="off"
          :placeholder="$trans('storefront::layout.search_for_products')"
          :value="form.query"
          @input="form.query = $event.target.value"
          @keydown.esc="hideSuggestions"
          @keydown.down="nextSuggestion"
          @keydown.up="prevSuggestion"
        />

        <button type="submit" class="btn btn-search"><i class="las la-search"></i></button>
      </form>
    </div>
    <div v-if="shouldShowSuggestions" class="search-suggestions">
      <div class="search-suggestions-inner custom-scrollbar" ref="searchSuggestionsInner">
        <div class="product-suggestion">
          <h6 class="title">{{ $trans("storefront::layout.product_suggestions") }}</h6>

          <ul class="list-inline product-suggestion-list">
            <li
              v-for="(product, index) in suggestions.products"
              :key="product.slug"
              class="list-item"
              :class="{ active: isActiveSuggestion(product) }"
              :ref="product.slug"
              @mouseover="changeActiveSuggestion(product)"
              @mouseleave="clearActiveSuggestion"
            >
              <a :href="product.url" class="single-item" @click="hideSuggestions">
                <div class="d-flex">
                  <!-- image -->
                  <div class="pr-1">
                    <img
                      :src="baseImage(product)"
                      :class="{ 'image-placeholder': !hasBaseImage(product) }"
                      class="rounded custom-product-image"
                      alt="product image"
                      @error="handleImageError"
                    />
                  </div>

                  <!-- details -->
                  <div class="d-flex w-100 pl-1">
                    <div class="d-flex flex-column w-100">
                      <h6 class="product-name text-dark text-wrap" v-html="product.name"></h6>

                      <div class="search-price">
                        <span class="formatted-price" v-html="productPrice(product)"></span>
                        <!--                        <span class="text-primary mx-1">|</span>-->
                        <span style="color: #343a40"
                        >Each <span style="color: #DEAA5E">({{ product.search_qty }} Available)
                          </span>
                        </span>
                      </div>

                      <div class="d-flex flex-column flex-md-row justify-content-between align-items-baseline">
                        <div class="d-flex">
                          <span v-if="product.is_out_of_stock" class="badge out-of-stock-badge px-3">Out Of Stock</span>
                          <span v-else class="badge in-stock-badge px-3">In Stock</span>
                          <div v-if="product.is_daily_deal_today" class="daily-deal-badge">
                            <small>Daily Deal ${{ currencyFormat(product.daily_deal_price) }} USD</small>
                          </div>
                          <div v-if="product.is_hot" class="hot-product-badge">
                            <img :src="hotImage" alt="" />
                            <small>Hot Product</small>
                          </div>
                          <div
                            v-if="product.is_rare_find" class="rare-find-product-badge width-fit-content">
                            <small>RareFind</small>
                          </div>
                        </div>

                        <button
                          class="btn btn-primary btn-add-to-cart btn-add-to-cart-search mt-1 mt-md-0"
                          :class="{ 'btn-loading': addingToCart }"
                          :disabled="product.is_out_of_stock"
                          @click="addToCart(product, $event)"
                        >
                          {{ $trans("storefront::product_card.add_to_cart") }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </a>
              <hr />
            </li>
          </ul>

          <a v-if="suggestions.remaining !== 0" :href="moreResultsUrl" @click="hideSuggestions" class="more-results">
            {{ $trans("storefront::layout.more_results", { count: this.suggestions.remaining }) }}
          </a>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import ProductHelpersMixin from "../../mixins/ProductHelpersMixin"
import DefaultImageMixin from "@core/mixin/DefaultImageMixin"

export default {
  mixins: [ProductHelpersMixin, DefaultImageMixin],
  props: ["categories", "mostSearchedKeywords", "isMostSearchedKeywordsEnabled", "initialQuery", "initialCategory"],
  data() {
    return {
      displayChart: false,
      hotImage: "themes/storefront/public/images/hot.svg",
      activeSuggestion: null,
      showSuggestions: false,
      form: {
        query: this.initialQuery,
        category: this.initialCategory
      },
      suggestions: {
        categories: [],
        products: [],
        remaining: 0
      }
    }
  },
  computed: {
    initialCategoryIsNotInCategoryList() {
      return !this.categories.includes(this.initialCategory)
    },
    shouldShowSuggestions() {
      if (!this.showSuggestions) {
        return false
      }

      return this.hasAnySuggestion
    },
    moreResultsUrl() {
      if (this.form.category) {
        return route("categories.products.index", this.form)
      }

      return route("products.index", { query: this.form.query })
    },
    hasAnySuggestion() {
      return this.suggestions.products.length !== 0
    },
    allSuggestions() {
      return [...this.suggestions.categories, ...this.suggestions.products]
    },
    firstSuggestion() {
      return this.allSuggestions[0]
    },
    lastSuggestion() {
      return this.allSuggestions[this.allSuggestions.length - 1]
    }
  },
  watch: {
    "form.query": function(newQuery) {
      if (newQuery === "") {
        this.clearSuggestions()
      } else {
        this.showSuggestions = true

        this.fetchSuggestions()
      }
    }
  },
  methods: {
    toggleDisplayChart() {
      this.displayChart = !this.displayChart
    },
    changeCategory(category) {
      this.form.category = category

      this.fetchSuggestions()
    },
    fetchSuggestions() {
      $.ajax({
        method: "GET",
        url: route("suggestions.index", { query: this.form.query })
      }).then(suggestions => {
        this.suggestions.categories = suggestions.categories
        this.suggestions.products = suggestions.products
        this.suggestions.remaining = suggestions.remaining

        this.clearActiveSuggestion()
        this.resetSuggestionScrollBar()
      })
    },
    search() {
      if (this.activeSuggestion) {
        window.location.href = this.activeSuggestion.url

        this.hideSuggestions()

        return
      }

      if (this.form.category) {
        window.location.href = route("categories.products.index", this.form)

        return
      }

      window.location.href = route("products.index", {
        query: this.form.query
      })
    },
    clearSuggestions() {
      this.suggestions.categories = []
      this.suggestions.products = []
    },
    hideSuggestions(e) {
      this.showSuggestions = false

      this.clearActiveSuggestion()
    },
    isActiveSuggestion(suggestion) {
      if (!this.activeSuggestion) {
        return false
      }

      return this.activeSuggestion.slug === suggestion.slug
    },
    changeActiveSuggestion(suggestion) {
      this.activeSuggestion = suggestion
    },
    clearActiveSuggestion() {
      this.activeSuggestion = null
    },
    nextSuggestion() {
      if (!this.hasAnySuggestion) {
        return
      }

      this.activeSuggestion = this.allSuggestions[this.nextSuggestionIndex()]

      if (!this.activeSuggestion) {
        this.activeSuggestion = this.firstSuggestion
      }

      this.adjustSuggestionScrollBar()
    },
    prevSuggestion() {
      if (!this.hasAnySuggestion) {
        return
      }

      if (this.prevSuggestionIndex() === -1) {
        this.clearActiveSuggestion()

        return
      }

      this.activeSuggestion = this.allSuggestions[this.prevSuggestionIndex()]

      if (!this.activeSuggestion) {
        this.activeSuggestion = this.lastSuggestion
      }

      this.adjustSuggestionScrollBar()
    },
    nextSuggestionIndex() {
      return this.currentSuggestionIndex() + 1
    },
    prevSuggestionIndex() {
      return this.currentSuggestionIndex() - 1
    },
    currentSuggestionIndex() {
      return this.allSuggestions.indexOf(this.activeSuggestion)
    },
    adjustSuggestionScrollBar() {
      this.$refs.searchSuggestionsInner.scrollTop = this.$refs[this.activeSuggestion.slug][0].offsetTop - 200
    },
    resetSuggestionScrollBar() {
      this.$refs.searchSuggestionsInner.scrollTop = 0
    },
    notLastItem(index) {
      return index !== this.suggestions.products.length - 1
    }
  }
}
</script>

<style>
.custom-product-image {
  height: 80px;
  width: 75px;
  object-fit: contain;
}

.rare-find-product-badge,
.hot-product-badge,
.daily-deal-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 4px;
  padding: 4px 14px;
  margin-right: 10px;
  gap: 5px;

  small {
    color: #ffffff;
    font-size: 12px;
  }
}

.hot-product-badge {
  background: #ff5656;
  color: #fff;
}

.rare-find-product-badge {
  background: green;
}

.daily-deal-badge {
  background: #40c887;
  color: #fff;
}

.out-of-stock-badge {
  background: #ffc656;
  color: #fff;
}

.in-stock-badge {
  background: var(--primary);
  color: #fff;
}

.out-of-stock-badge,
.in-stock-badge {
  height: 25px;
  min-width: fit-content;
  border-radius: 4px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  margin-right: 10px;
}
</style>
